import AbstractChannel from './AbstractChannel'

export default class OnAirParking extends AbstractChannel {

  name = 'noson'
  title = 'On Air Parking'
  titleShort = 'On Air'
  color = '#98DF8A'

  supportedFeatures = ['blackouts']

}
